import { useQuery } from "@apollo/client";
import classNames from "classnames";
import React from "react";
import { useLocation } from "react-router";
import style from "../assets/css/page/TableTeamPlayers.module.css";
import EfficiencyPlayerRadial from "../components/Chart/EfficiencyPlayerRadial";
import LogoHeader from "../components/Header/LogoHeader";
import Loading from "../components/Loading";
import { GET_TEAM_PLAYERS } from "../graphql/queries";

function TableTeamPlayers() {
  const location = useLocation();

  const { data, loading, error } = useQuery(GET_TEAM_PLAYERS, {
    variables: {
      IdTeam: location.state?.idTeam,
      State: "LIVE",
    },
  });

  if (loading) return <Loading />;

  if (error)
    return (
      <div>
        <p>Lo sentimos a ocurrido un error al traer los datos</p>
      </div>
    );

  return (
    <div className={style.container}>
      <div className={style.header}>
        <LogoHeader />
        <p className={style.nameTeam} style={{ color: data?.team?.colorShirt }}>
          {data?.team?.name}
        </p>
      </div>
      <div className={style.contTable}>
        <table className={style.table}>
          <thead className={style.headTable}>
            <tr className={style.row}>
              <td className={style.column}>Nombre</td>
              <td className={style.column}>Estatus</td>
              <td className={style.column}>Datos de juegos</td>
              <td className={style.column}></td>
            </tr>
          </thead>
          <tbody className={style.bodyTable}>
            {data.team.players?.map((player, index) => (
              <RowData
                key={index}
                player={player}
                color={data?.team?.colorShirt}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const RowData = ({ player, color }) => {
  const getTotalPlayed = () => {
    if (player.dayRegister <= 3) {
      return 17;
    } else if (player.dayRegister === 8) {
      return 10;
    } else {
      return 0;
    }

    /*
    switch (new Date(player.createdAt).getMonth() + 1) {
      case 4:
      case 5:
        return 26;
      case 6:
      case 7:
        return 19;
      case 8:
        return 13;
      default:
        return 0;
    }*/
  };

  const getPercentage = () => {
    let percentage = Math.round((player.played * 100) / getTotalPlayed());

    console.log(percentage);

    return percentage;
  };

  const getNeedGames = () => {
    let need = Math.trunc(getTotalPlayed() / 2) + 1 - player.played;

    if (need > 0) {
      return "+ " + need;
    } else {
      return "";
    }
  };

  return (
    <tr className={style.row}>
      <td className={style.data}>
        {`${player.name} ${player.app} ${player.apm}`}
      </td>
      <td className={style.data}>
        <p
          className={
            getPercentage() < 51
              ? style.status
              : classNames(style.status, style.playoffs)
          }
        >
          Liguilla
        </p>
      </td>
      <td className={classNames(style.data, style.contGames)}>
        <div className={style.games}>
          <p className={style.numPlayer}>
            {player.played < 10 ? "0" + player.played : player.played}
            <span className={style.total}>/ {getTotalPlayed()}</span>
          </p>
          <p className={classNames(style.textGames, style.percentage)}>
            {getPercentage()} %
          </p>
          <p className={classNames(style.textGames, style.needGames)}>
            {getNeedGames()}
          </p>
        </div>
      </td>
      <td className={style.data}>
        <div className={style.contGraph}>
          <EfficiencyPlayerRadial teamColor={color} series={getPercentage()} />
        </div>
      </td>
    </tr>
  );
};

export default TableTeamPlayers;
